var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFigurebowling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24.1055 26.9648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 26.9648,
    opacity: 0,
    width: 24.1055,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7617 5.10938C20.168 5.10938 21.3047 3.97266 21.3047 2.54297C21.3047 1.13672 20.168 0 18.7617 0C17.332 0 16.1953 1.13672 16.1953 2.54297C16.1953 3.97266 17.332 5.10938 18.7617 5.10938ZM9.70312 14.9883L15.668 19.5352L13.8164 25.2539C13.5469 26.0742 14.0625 26.6602 14.6836 26.8125C15.2344 26.9414 15.8789 26.707 16.125 25.9336L18.1992 19.5234C18.3516 19.0547 18.2695 18.5508 17.9414 18.2344L13.9336 14.2266L18.5391 9.60938C18.7383 9.41016 19.043 9.41016 19.2422 9.60938L20.8359 11.1914L18.6562 13.3711C18.1758 13.8633 18.1875 14.625 18.6562 15.0938C19.1016 15.5273 19.8867 15.5742 20.3672 15.0938L23.4023 12.0586C23.8828 11.5781 23.8711 10.8281 23.4023 10.3477L20.4727 7.39453C19.7695 6.69141 18.9258 6.33984 17.918 6.33984L3.84375 6.33984C3.1875 6.33984 2.63672 6.87891 2.63672 7.54688C2.63672 8.21484 3.1875 8.76562 3.84375 8.76562L11.9297 8.76562C12.3398 8.76562 12.5273 9.1875 12.2344 9.48047L9.89062 11.8242C8.83594 12.8789 8.98828 14.4492 9.70312 14.9883ZM9.35156 16.1367L8.76562 19.6992L3.15234 19.6992C2.46094 19.6992 1.92188 20.2383 1.92188 20.918C1.92188 21.5859 2.46094 22.125 3.15234 22.125L9.73828 22.125C10.3711 22.125 10.793 21.8086 10.957 21.2461L11.9062 18.0938ZM2.63672 12.8203C4.07812 12.8203 5.27344 11.6367 5.27344 10.1836C5.27344 8.74219 4.07812 7.54688 2.63672 7.54688C1.18359 7.54688 0 8.74219 0 10.1836C0 11.6367 1.18359 12.8203 2.63672 12.8203Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigurebowling);
export default __webpack_public_path__ + "static/media/figure.bowling.e68e954532cc865f9a6d42a0e2f971af.svg";
export { ForwardRef as ReactComponent };